import style from "./PromptsSelector.module.scss";
import { prebuiltPrompts } from "../../../constants/prebuiltPrompts";

function PromptsSelector({ changeSettings, changePrompt }) {
	const changeHandler = (negativePrompt, prompt) => {
		changeSettings(negativePrompt, "negative_prompt");
		changePrompt(prompt);
	};
	return (
		<div className={style.container}>
			<div className={style.scroll}>
				{prebuiltPrompts.map((item) => {
					return (
						<button className={style.button} key={item.id} onClick={() => changeHandler(item.negative_prompt, item.prompt)}>
							{item.name}
						</button>
					);
				})}
			</div>
		</div>
	);
}

export default PromptsSelector;
